import React from 'react';
import styled from 'styled-components';
import { HeadlineOne } from 'components/atoms/SectionWrapper.style';

const ProcesPartWrapper = styled.div`
  text-align: center;
  margin-top: 100px;
  ol {
    li {
      text-align: left;
      margin: 7px;
      font-size: 20px;
    }
  }
`;

const ProcesPart = () => (
  <>
    <ProcesPartWrapper>
      <HeadlineOne>Element procesu</HeadlineOne>
      <ol>
        <li>Mapa archiwalna dla pow. ok. 1,5 ha</li>
        <li>Mapa do celów projektowych</li>
        <li>Decyzja środowiskowa</li>
        <li>
          Raport o wpływie na środowisko – jeżeli będzie wymóg sporządzenia
        </li>
        <li>Opłata różne administracyjne</li>
        <li>Badanie gruntu</li>
        <li>Projekt budowlany do pnb</li>
        <li>Analiza oddziaływania na sieć energetyczną</li>
        <li>Warunki przyłączenia procedura</li>
        <li>W przypadku bycia inwestorem za war. przyłączenia 1 MW</li>
        <li>Uzgodnienia wykonawcze + pozwolenie na budowę</li>
        <li>Szacunkowy koszt budowy elektrowni o mocy 1 MW</li>
      </ol>
    </ProcesPartWrapper>
  </>
);

export default ProcesPart;
